export abstract class BaseAthleteAnswer {
    public type:any;

    private _data: any = null;

    set data(data: any) {
        this._data = data;
    }

    get data(): any {
        return this._data;
    }
}

export default BaseAthleteAnswer;
